module.exports = __webpack_public_path__ + "static/media/Wurmple_gaussian2.4e89e272.png";